import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IconLoaderService } from '../../icon-loader.service';
import { PipelineProperty, ReportInfo, ReportView } from '../../models/report.model';
import { ReportAllRecordsImage } from '../../models/template.model';
import { ReportExportViewService } from '../../report-export-view.service';
import { ReportImagesService } from '../../report-images.service';

@Component({
  selector: 'rep-development-pipeline-view',
  templateUrl: './development-pipeline-view.component.html',
  styleUrls: ['./development-pipeline-view.component.scss'],
  standalone: false,
})
export class DevelopmentPipelineViewComponent {
  displayedColumns: string[] = ['FLOOR', 'SQM', 'SQFT'];
  propertiesCount: number;
  property = {} as PipelineProperty;
  totalProperties: PipelineProperty[];
  showNavigationArrows: boolean = false;
  @Input() reportData: ReportInfo;
  @Input() currentView: ReportView;

  constructor(
    private reportExportViewService: ReportExportViewService,
    private reportImagesService: ReportImagesService,
    private iconLoaderService: IconLoaderService,
    private router: Router
  ) {}

  ngOnChanges() {
    this.fetchAdditionalImagesOfReport();
    const properties = this.reportData.pipeline.map(pipeline => pipeline.properties);
    // flatten the nested array
    this.totalProperties = [].concat(...properties);
    this.propertiesCount = this.totalProperties.length;
    if (this.propertiesCount > 1) {
      this.property = this.totalProperties[0];
    }
  }

  navRecordNum(event) {
    this.property = this.totalProperties[event - 1];
  }

  /**
   * this method is used to fetch the additional image id of the report.
   */
  private fetchAdditionalImagesOfReport() {
    this.reportExportViewService.getImages(this.reportData.reportId).subscribe((res: ReportAllRecordsImage) => {
      this.reportImagesService.setReportRecordImages(res);
    });
  }

  goToRecord() {
    const { entity } = this.reportData;
    const url = `/records/${entity}/${this.property.id}/edit`;
    this.router.navigateByUrl(url);
  }
}
